import { Link, useLocation } from "react-router-dom";

const navItems = [
  { to: "/",        icon: "📊", label: "Dashboard"    },
  { to: "/drivers", icon: "🚗", label: "Chauffeurs"   },
  { to: "/rides",   icon: "🛣️", label: "Courses"      },
  { to: "/revenue", icon: "💰", label: "Revenus"      },
  { to: "/tarifs",  icon: "💲", label: "Tarifs"       },
  { to: "/tarifs-regions", icon: "🗺️", label: "Tarifs régions" },
  { to: "/map",     icon: "🗺️", label: "Live Map"     },
  { to: "/tracking",icon: "📍", label: "Tracking"     },
  { to: "/heatmap", icon: "🔥", label: "Heatmap"      },
  { to: "/support", icon: "🎧", label: "Support"      },
  { to: "/notifications", icon: "🔔", label: "Notifications" },
  { to: "/commission", icon: "💸", label: "Commissions" },
  { to: "/users", icon: "👤", label: "Utilisateurs" },
  { to: "/trips", icon: "🚌", label: "Inter-régions" },
  { to: "/pickup-points", icon: "📍", label: "Points arrêt" },

];

export default function Layout({ children }) {
  const location = useLocation();

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>

      {/* SIDEBAR */}
      <div style={{
        width: 220,
        background: "#0B3C5D",
        color: "#fff",
        padding: "20px 12px",
        display: "flex",
        flexDirection: "column",
        position: "sticky",
        top: 0,
        height: "100vh",
        overflowY: "auto",
      }}>

        {/* Logo */}
        <div style={{ padding: "8px 12px 24px" }}>
          <div style={{ fontSize: 20, fontWeight: 700, color: "#FFA500", letterSpacing: 1 }}>
            🚗 DIEULSIMA
          </div>
          <div style={{ fontSize: 11, color: "rgba(255,255,255,0.4)", marginTop: 4 }}>
            Dashboard Admin
          </div>
        </div>

        {/* Nav */}
        <nav style={{ flex: 1 }}>
          {navItems.map(({ to, icon, label }) => {
            const active = location.pathname === to;
            return (
              <Link
                key={to}
                to={to}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  padding: "10px 12px",
                  borderRadius: 8,
                  marginBottom: 4,
                  textDecoration: "none",
                  fontSize: 14,
                  fontWeight: active ? 600 : 400,
                  background: active ? "rgba(255,165,0,0.15)" : "transparent",
                  color: active ? "#FFA500" : "rgba(255,255,255,0.75)",
                  borderLeft: active ? "3px solid #FFA500" : "3px solid transparent",
                  transition: "all 0.15s",
                }}
              >
                <span style={{ fontSize: 16 }}>{icon}</span>
                {label}
              </Link>
            );
          })}
        </nav>

        {/* Logout */}
        <button
          onClick={() => {
            localStorage.removeItem("adminToken");
            window.location.href = "/login";
          }}
          style={{
            marginTop: 16,
            background: "rgba(255,255,255,0.08)",
            color: "#fff",
            border: "0.5px solid rgba(255,255,255,0.15)",
            padding: "10px 16px",
            borderRadius: 8,
            cursor: "pointer",
            fontSize: 13,
            display: "flex",
            alignItems: "center",
            gap: 8,
            width: "100%",
          }}
        >
          🚪 Déconnexion
        </button>
      </div>

      {/* CONTENU */}
      <div style={{
        flex: 1,
        padding: "24px 28px",
        background: "#F5F7FA",
        overflowY: "auto",
      }}>
        {children}
      </div>

    </div>
  );
}